import {
  AlertArea,
} from '@codev/helix-react';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './Frame.css';

const Frame = ({
  children,
  style,
  title,
}) => (
  <div className={styles.container}>
    <div className={styles.wrapper}>
      <AlertArea />
      <div className={styles.header}>
        {title}
      </div>
      <div className={styles.body} style={style}>
        {children}
      </div>
    </div>
  </div>
);

Frame.propTypes = {
  children: PropTypes.node,
  style: PropTypes.object,
  title: PropTypes.string,
};

export default Frame;
